import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import { MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import logo from "../../../Assets/Images/logo.svg";
import { forgotPassword } from "../../../API/auth";
import PortalConfig, {
  setResetPasswordPortal,
} from "../../../Utlis/PortalConfig";
import "./style.css";

const ForgotPassword = ({ setUser, portal }) => {
  const config = PortalConfig[portal];
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const onFinish = async (values) => {
    setLoading(true);
    const tenantType = config.loginTenantTypes[0];
    const res = await forgotPassword({
      email: values.email,
      tenant_type: tenantType,
    });
    setLoading(false);

    if (res?.status === 200) {
      setResetPasswordPortal(portal);
      message.success(res?.data?.detail || "A reset link has been sent to your email.");
      navigate("/verify-email", {
        state: { email: values.email, tenantType },
      });
    } else {
      message.error(res?.data?.detail || "Could not send reset link.");
    }
  };

  const handleBackToLogin = () => {
    setUser(config.userValue);
    navigate(config.loginRoute);
  };

  return (
    <div className="forgot">
      <div className="forgot-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="forgot-card">
          <div className="top-gradient"></div>
          <div className="content-heading">Forgot Your Password</div>
          <div className="sub-heading">
            Enter your registered email address to receive reset instructions.
          </div>
          <Form
            name="register"
            layout="vertical"
            autoComplete="off"
            initialValues={{ email: location.state?.email }}
            onFinish={onFinish}
          >
            <Form.Item
              label="Email Address"
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Enter a valid email!" },
              ]}
            >
              <Input
                placeholder="Enter your email address"
                prefix={<MailOutlined />}
              />
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="submit-button"
              loading={loading}
            >
              Send Reset Link
            </Button>

            <Button className="back-to-login" onClick={handleBackToLogin}>
              <ArrowLeftOutlined />
              Back to Login
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
